export enum AUTH_METHODS {
    OTP = 'OTP',
    // EMAIL = 'EMAIL',
}